import { Card } from "@/components/ui/card";
import { TrendingUp, Shield, DollarSign, Clock } from "lucide-react";
import { motion } from "framer-motion";

export const TrustKPIs = () => {
  const kpis = [
    {
      icon: DollarSign,
      value: "$1,548",
      label: "Avg. Market Rent",
      color: "text-accent",
    },
    {
      icon: TrendingUp,
      value: "Proven",
      label: "Track Record",
      color: "text-primary",
    },
    {
      icon: Shield,
      value: "High",
      label: "Collection Rate",
      color: "text-accent",
    },
    {
      icon: Clock,
      value: "6",
      label: "Metro Areas",
      color: "text-primary",
    },
  ];

  return (
    <section className="py-14 sm:py-18 lg:py-20 bg-secondary/30">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
          {kpis.map((kpi, index) => {
            const Icon = kpi.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ delay: index * 0.1, duration: 0.4 }}
              >
                <Card
                  data-testid="trust-kpi-item"
                  className="p-4 sm:p-5 shadow-[0_10px_30px_rgba(15,42,74,0.06)] hover:shadow-[0_16px_45px_rgba(15,42,74,0.10)] transition-shadow"
                >
                  <Icon className={`h-8 w-8 mb-3 ${kpi.color}`} />
                  <div className="text-2xl sm:text-3xl font-semibold font-display tabular-nums tracking-tight text-foreground mb-1">
                    {kpi.value}
                  </div>
                  <div className="text-xs sm:text-sm text-muted-foreground">
                    {kpi.label}
                  </div>
                </Card>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TrustKPIs;
